import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    gap: "27px",
    flex: 1,
    height: "270px",
    padding: "26px"
  },
  mandatoryWrapper: {
    border: "1px solid #F2F3F7",
    backgroundColor: "#FCFDFD",
    maxHeight: "240px",
    overflow: "auto",
    padding: "16px"
  },
  financeWrapper: {
    border: "1px solid #F2F3F7",
    backgroundColor: "#FCFDFD",
    maxHeight: "240px",
    overflow: "auto",
    padding: "16px"
  },
  emptyWrapper: {
    border: "1px solid #F2F3F7",
    backgroundColor: "#FCFDFD",
    flex: "1",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    color: "#373534",
    fontWeight: "600",
    marginBottom: "6px",
  },
  subTitle: {
    color: theme.palette.primary.primary500,
    fontSize: "12px",
    fontWeight: 600,
  },
  function: {
    color: "#656575",
    fontSize: "12px",
  },
  financeTurnover: {
    fontWeight: 600,
    color: theme.palette.primary.primary800,
  },
  financeDateAndWorkForce: {
    color: "#9A9AAF",
    fontSize: "12px",
    display: "flex",
    gap: "10px"
  },
  financeItemWrapper: {
    backgroundColor: "white",
    padding: "5px",
    boxShadow: "0px 6px 16px 0px rgba(21, 12, 115, 0.06)",
    borderRadius: "10px",
  },
}));

export default useStyles;
